import StaticHeaderInfo from "components/pages/web/static/staticHeaderInfo";
import { Trans, useTranslation } from "react-i18next";
import { Card, CardBody, CardTitle, Col, Container, Row } from "reactstrap";
import UserMobile from "assets/image/user-mobile.png";
import Tick from "assets/image/tick.png";
import FingerPrint from "assets/image/fingerprint.png";

const Security = () => {
  const { t } = useTranslation();

  const securityItem = [
    "Complete encryption of sensitive information during transfer and storage",
    "Use artificial intelligence to identify suspicious activity",
    "Equipped with SSL certificate for authentication and site security",
  ];

  const securityItemTwo = [
    "Complete encryption of sensitive information during transfer and storage",
    "Use artificial intelligence to identify suspicious activity",
    "Equipped with SSL certificate for authentication and site security",
  ];

  const securityItemThree = [
    {
      title: "Take care of user information with firewalls",
      text: "All_data_exchanged",
    },
    {
      title: "Steel protection of users' digital capital",
      text: "Secure_services",
    },
    { title: "Impermeable internal servers", text: "All_user_information" },
    { title: "All-Tech Development Team", text: "Protecting_users" },
  ];
  const securityItemFour = [
    "<0>Special care for users' accounts</0>",
    "To maintain the security of user accounts, security principles have been observed at all levels of the Quinnic Market panel, including",
    "Two-step verification via SMS and Google Authenticator",
    "Use artificial intelligence to identify suspicious cases",
    " Store all user information encrypted",
    "Login notification via SMS and email",
    "Limit the number of user logins per hour to prevent brute force attacks",
  ];
  const securityItemFive = [
    "<0>Committed to helping increase the security of Iran's crypto ecosystem</0>",
    "Mission_ncrease",
  ];

  return (
    <>
      <StaticHeaderInfo>
        <div className="title-style mb-5 mb-md-0">
          <span className="text-light fs-2 fw-bold ">
            {t("Security at oinnik Market")}
          </span>
        </div>
      </StaticHeaderInfo>
      <Container>
        <Card className="shadow border-radius-1 mt-lg-3  mt-n5 mt-md-0">
          <CardBody>
            <Row>
              <Col md="12" lg="6">
                <CardTitle className="mb-5">
                  <span className="title-bordre-bottom ">
                    {t(
                      "Terms, Conditions and Contracts for the Use of coinnik Market Services"
                    )}
                  </span>
                </CardTitle>
                <p className="text-secondary-two-light">
                  {t("Holistic_approach")}
                </p>
              </Col>
              <Col md="12" lg="6" className="d-flex justify-content-end">
                <img
                  src={UserMobile}
                  alt="image"
                  className="securty-img-style"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <p className="fw-medium">
                  {t("Coinnik Market Security Test Results")}
                </p>
                <p>
                  <Trans
                    i18nKey="transfer_security"
                    components={[
                      <a
                        href="https://www.ssllabs.com/ssltest/analyze.html?d=coinnik.market&latest"
                        className="fw-medium text-warning-light"
                      />,
                    ]}
                  />
                </p>
              </Col>
            </Row>
            <Row>
              <p className="fw-medium pt-4">
                {t("Kevin Nick Market security features")}
              </p>
              <Col xs="12" md="6" className="list">
                <ul>
                  {securityItem.map((item) => (
                    <li className="py-3">
                      <img src={Tick} />
                      <span className="px-2">{t(item)}</span>
                    </li>
                  ))}
                </ul>
              </Col>
              <Col xs="12" md="6" className="list">
                <ul>
                  {securityItemTwo.map((item) => (
                    <li className="py-3">
                      <img src={Tick} />
                      <span className="px-2">{t(item)}</span>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center ">
              <div className="d-flex justify-content-center pt-5 pb-3 ">
                <p className="fw-medium pt-4">
                  {t("Why trust the security of Kevin Nick Market?")}
                </p>
              </div>
              {securityItemThree.map((item) => (
                <Col xs="12" md="5" className="mb-2 ">
                  <Card className="shadow border-radius-1">
                    <CardBody>
                      <CardTitle>
                        <span className="fs-6 text-secondary-two-light fw-medium">
                          {t(item.title)}
                        </span>
                      </CardTitle>
                      <p className="text-secondary-two-light">{t(item.text)}</p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
            <Row className="py-6">
              <Col sm="12" xl="7" className="list security-list-style">
                <ul>
                  {securityItemFour.map((item) => (
                    <li className="py-2">
                      <img src={Tick} />
                      <Trans
                        i18nKey={item}
                        components={[<span className="fw-medium px-2" />]}
                      />
                    </li>
                  ))}
                </ul>
              </Col>
              <Col sm="12" xl="5" className="d-flex justify-content-end">
                <img
                  src={FingerPrint}
                  alt="image"
                  className="securty-img-style"
                />
              </Col>
            </Row>
            <Row>
              <Col xl="12">
                {securityItemFive.map((item) => (
                  <p className="text-secondary-two-light">
                    <Trans
                      i18nKey={item}
                      components={[<span className="fw-medium px-2" />]}
                    />
                  </p>
                ))}
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};
export default Security;
